<template>
  <div class="popup-bg" v-if="show && popup">
    <div :class="popup.class">
      <a :href = "popup.href" target="_blank">
        <img :src="popup.src" alt="popupimg"/>
      </a>
      <div class="popup-btn-wrap">
        <v-checkbox class="popup-check" color="#ffffff" style='font-family: "NanumSquareNeoBold" !important;font-size: 16px!important;color: #fff !important;' v-model="checkbox" label="오늘 하루 보지 않기"></v-checkbox>
        <button class="popup-btn" @click="toggleShow">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    popup: Object,
  },
  data: () => ({
    show: true,
    checkbox: false,
  }),
  beforeMount() {
    const popupNotShow = localStorage.getItem(`popupNotShow-${this.popup.idx}`);
    if (popupNotShow && popupNotShow > new Date()) {
      this.show = false;
    }

    if (new Date() > new Date(2022,8,30)) {
      this.show = false;
    }

    if (this.popup.idx == 3 && new Date() > new Date(2022, 8, 13)) {
      this.show = false;
    }
  },
  methods: {
    toggleShow() {
      if (this.checkbox) {
        let expires = new Date();
        expires = expires.setHours(expires.getHours() + 24);
        localStorage.setItem(`popupNotShow-${this.popup.idx}`, expires);
      }
      this.show = !this.show;
    },
  },
};
</script>

<style scoped>
@media all and (min-width: 1024px) {
  .w-none {
    display: none !important;
  }
  .popup-wrap {
    position: absolute;
    top: 3%;
    left: 100px;
    z-index: 9999;
  }
  .popup-wrap.popup-2 {
    position: absolute;
    top: 3%;
    left: 650px;
    z-index: 9999;
  }
  .popup-wrap img {
    width: 450px;
    height: auto;
  }
  .popup-btn-wrap{
    display: block;
    height: 53px;
    overflow: hidden;
    padding: 15px;
    border: none;
    background: rgb(51, 51, 51);
    text-align: center;
    margin-top: -8px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
  .popup-btn-wrap .popup-check{
    float: left;
    flex: none;
    margin: 0;
    padding: 0;
  }
  .popup-btn-wrap .popup-btn{
    font-family: "NanumSquareNeoBold";
    float: right;
    padding: 0 15px;
    font-size: 16px;
  }
}
@media all and (min-width: 768px) and (max-width: 1023px) {
  .t-none {
    display: none !important;
  }
  .popup-bg {
    background: rgba(51, 51, 51, 0.616);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 900;
    overflow-y: scroll;
  }
  .popup-wrap {
    width: 60%;
    padding: 50px 0;
    position: absolute;
    top: 3%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
  }
  .popup-wrap.popup-2 {
    width: 45%;
    position: absolute;
    top: 3%;
    left: 52.5%;
    z-index: 9999;
  }
  .popup-wrap img {
    width: 100%;
    height: auto;
  }
  .popup-btn-wrap{
    display: block;
    height: 53px;
    overflow: hidden;
    padding: 15px;
    border: none;
    background: rgb(51, 51, 51);
    text-align: center;
    margin-top: -8px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
  .popup-btn-wrap .popup-check{
    float: left;
    flex: none;
    margin: 0;
    padding: 0;
  }
  .popup-btn-wrap .popup-btn{
    font-family: "NanumSquareNeoBold";
    float: right;
    padding: 0 15px;
    font-size: 16px;
  }
}
@media all and (max-width: 767px) {
  .m-none {
    display: none !important;
  }
  .popup-bg {
    background: rgba(51, 51, 51, 0.616);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 900;
  }
  .popup-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 80px 40px 40px;
  }
  .popup-wrap img {
    width: 100%;
    height: auto;
  }
  .popup-btn-wrap{
    overflow:hidden;
    width: 100%; height: 55px;
    padding: 0 40px;
    position: absolute;
    right: 0;
    top: 35px;
  }
  .popup-btn-wrap .popup-check{
    float: left;
    flex: none;
    margin: 0;
    padding: 0 0 0 15px;
  }
  .popup-btn-wrap .popup-btn{
    font-family: "NanumSquareNeoBold";
    float: right;
    padding: 0 15px;
    font-size: 16px;
    color: #fff;
  }
}
</style>